module.exports = __webpack_public_path__ + "static/media/ojk.546ed156.svg";